<template>
  <v-container fluid>
    <template v-if="$store.getters.usuario.idRol == 1">
      <v-row justify="center" class="mt-4">
        <v-col cols="12" sm="6">
          <v-select
            :items="tareas"
            item-value="idTarea"
            item-text="descripcion"
            :menu-props="{ maxHeight: '400' }"
            prepend-icon="mdi-clipboard-list-outline"
            label="Tarea"
            no-data-text="No se encontraron tareas."
            hint="Seleccione la tarea."
            persistent-hint
          ></v-select>
        </v-col>
      </v-row>
    </template>
    <v-row justify="center" class="mt-4">
      <v-col cols="6" class="center">
        <template v-if="$store.getters.usuario.idRol == 1">
          <v-row justify="center" class="mb-2">
            <v-btn
              color="primary"
              :loading="isSaving"
              depressed
              @click="isSaving = true"
            >
              <v-icon left dark>mdi-clipboard-text-play</v-icon>

              Listar Tareas</v-btn
            >
          </v-row>
        </template>
        <br />
        <v-col cols="12" sm="12">
          <v-card>
            <v-form ref="form">
              <v-card-title class="justify-center"
                ><h4>Listado de Tareas Pendientes</h4>
              </v-card-title>
              <v-text-field
                v-model="buscar"
                append-icon="mdi-magnify"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field>
              <v-data-table
                :headers="headers"
                :items="desserts"
                :search="buscar"
                :header-props="headerProps"
                hide-default-footer
                no-data-text="No se encontraron registros"
                no-results-text="No se encontraron registros en la búsqueda"
              >
              </v-data-table>
              <br />
              <v-row justify="center" class="mb-2">
                <v-btn color="primary" depressed>
                  <v-icon left dark>mdi-file-excel-outline</v-icon>

                  Exportar a Excel</v-btn
                >
              </v-row>
              <br />
            </v-form>
          </v-card>
        </v-col>
      </v-col>
      <!-- @click="isSaving = true" -->
    </v-row>
    <AlertSnackBar ref="AlertSnackBar" color="#7bae00"></AlertSnackBar>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      buscar: "",
      alertShow: false,
      isSaving: false,
      show1: false,
      headerProps: {
        sortByText: "Ordenar por",
      },

      tareas: [
        {
          idTarea: "0",
          descripcion: "O.K.",
        },
        {
          idTarea: "11",
          descripcion: "SUSPENSION FALTA DE PAGO A REALIZAR",
        },
        {
          idTarea: "12",
          descripcion: "SUSPENSION FALTA DE PAGO EXIMIDO",
        },
        {
          idTarea: "13",
          descripcion: "SUSPENSION FALTA DE PAGO A CONFIRMAR",
        },
        {
          idTarea: "14",
          descripcion: "SUSPENSION FALTA DE PAGO AVISO EMITIDO",
        },
        {
          idTarea: "15",
          descripcion: "SUSPENSION FALTA DE PAGO ORDEN EMITIDA",
        },
        {
          idTarea: "16",
          descripcion: "SUSPENSION FALTA DE PAGO ORDEN EJECUTADA",
        },
      ],

      headers: [
        {
          text: "Dessert (100g serving)",
          align: "start",
          filterable: true,
          value: "name",
          class: "black white--text",
        },
        { text: "Calories", value: "calories", class: "black white--text" },
        { text: "Fat (g)", value: "fat", class: "black white--text" },
        { text: "Carbs (g)", value: "carbs", class: "black white--text" },
        { text: "Protein (g)", value: "protein", class: "black white--text" },
        { text: "Iron (%)", value: "iron", class: "black white--text" },
      ],
      desserts: [
        {
          name: "Frozen Yogurt",
          calories: 159,
          fat: 6.0,
          carbs: 24,
          protein: 4.0,
          iron: "1%",
        },
        {
          name: "Ice cream sandwich",
          calories: 237,
          fat: 9.0,
          carbs: 37,
          protein: 4.3,
          iron: "1%",
        },
        {
          name: "Eclair",
          calories: 262,
          fat: 16.0,
          carbs: 23,
          protein: 6.0,
          iron: "7%",
        },
        {
          name: "Cupcake",
          calories: 305,
          fat: 3.7,
          carbs: 67,
          protein: 4.3,
          iron: "8%",
        },
        {
          name: "Gingerbread",
          calories: 356,
          fat: 16.0,
          carbs: 49,
          protein: 3.9,
          iron: "16%",
        },
        {
          name: "Jelly bean",
          calories: 375,
          fat: 0.0,
          carbs: 94,
          protein: 0.0,
          iron: "0%",
        },
        {
          name: "Lollipop",
          calories: 392,
          fat: 0.2,
          carbs: 98,
          protein: 0,
          iron: "2%",
        },
        {
          name: "Honeycomb",
          calories: 408,
          fat: 3.2,
          carbs: 87,
          protein: 6.5,
          iron: "45%",
        },
        {
          name: "Donut",
          calories: 452,
          fat: 25.0,
          carbs: 51,
          protein: 4.9,
          iron: "22%",
        },
        {
          name: "KitKat",
          calories: 518,
          fat: 26.0,
          carbs: 65,
          protein: 7,
          iron: "6%",
        },
      ],
    };
  },
  watch: {
    isSaving(val) {
      if (val) {
        this.$refs.AlertSnackBar.Abrir("Descargando Tareas...");
        setTimeout(() => (this.isSaving = false), 1500);
      } else {
        //  this.$router.push("Principal");
      }
    },
  },
  mounted() {},
  methods: {
    orderList() {
      this.list = this.list.sort((one, two) => {
        return one.order - two.order;
      });
    },
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    },
  },
};
</script>
